import {IProtocolStats} from "../../types/IProtocolStats";
import {Box, Text} from "@mantine/core";
import cx from "clsx";
import classes from "./SessionRow.module.css";
import commonClasses from "../../../../common/common.module.css";
import {dayjsToDisplayString} from "../../../../common/utils/times";
import {DashboardIcons} from "../../common/constants";
import {useNavigate} from "react-router";
import {showGTZero} from "../../common/utils";


interface SessionRowProps {
    stats: IProtocolStats
    showSubject: boolean
}

export const SessionRow: React.FC<SessionRowProps> = ({stats, showSubject = true}: SessionRowProps) => {
    const navigate = useNavigate()


    return (
        <Box mt={"1em"}
             className={cx("ntc-maximum-component", commonClasses.tgBorder, commonClasses.sbRadius)}>
            <Box className={cx(classes.root, commonClasses.hover, commonClasses.sbRadius)}
                 onClick={() => navigate(`/analysis/dashboards/protocol/${stats.id}`)}>
                <DashboardIcons.calendarIcon/>
                <Box>
                    {dayjsToDisplayString(stats.startTime)}
                </Box>
                {showSubject &&
                    <Box ml="1em" className={"ntc-row-component ntc-flex-align-center"}>
                        <DashboardIcons.subjectIcon mr={"0.25em"} size={"1em"}/>{stats.subjectName}
                    </Box>
                }
                {showGTZero(stats.stimCount,
                    <Box className={"ntc-row-component ntc-flex-align-center"}>
                        <DashboardIcons.stimulationsIcon ml={"0.25em"} size={"1em"}/>{stats.stimCount} <Text
                        ml={"0.25em"}> stimulations</Text>
                    </Box>
                )
                }
                {showGTZero(stats.stimCount,
                    <Box className={"ntc-row-component ntc-flex-align-center"}>
                        <DashboardIcons.megScanIcon mr={"0.25em"} size={"1em"}/>{stats.megScanCount}
                        <Text ml={"0.25em"}>
                            MEG scans
                        </Text>
                    </Box>
                )}
                {showGTZero(stats.stimCount,
                    <Box className={"ntc-row-component ntc-flex-align-center"}>
                        <DashboardIcons.eegScanIcon mr={"0.25em"} size={"1em"}/>{stats.eegScanCount}
                        <Text ml={"0.25em"}>
                            EEG scans
                        </Text>
                    </Box>
                )}
                {showSubject ? "" : <Box/>}
                <Box style={{justifySelf: "end"}}>
                    <Text ml={"0.25em"}>
                        {stats.name}
                    </Text>
                </Box>
            </Box>
        </Box>
    )
}